/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Google_Drive_ConnectInputs */

const en_google_drive_connect = /** @type {(inputs: Google_Drive_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect Google Drive`)
};

const es_google_drive_connect = /** @type {(inputs: Google_Drive_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conectar Google Drive`)
};

/**
* | output |
* | --- |
* | "Connect Google Drive" |
*
* @param {Google_Drive_ConnectInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const google_drive_connect = /** @type {((inputs?: Google_Drive_ConnectInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Google_Drive_ConnectInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_google_drive_connect(inputs)
	return en_google_drive_connect(inputs)
});